<template>
  <div class="curriculumSchedule">
    <!-- 标题栏 -->
    <!-- <van-nav-bar :title="category" left-arrow @click-left="onClickLeft" /> -->
    <!-- 内容 -->
    <div class="page">
      <!-- <div class="kqb-tab">
        <div class="kqb-tab-item" :class="[current == 0?'active':'']" @click="switchTab('0')">
          <span>音频</span>
          <div class="tab-line"></div>
        </div>
        <div class="kqb-tab-item" :class="[current == 1?'active':'']" @click="switchTab('1')">
          <span>视频</span>
          <div class="tab-line"></div>
        </div>
      </div> -->
      <div class="kqb-tab-content">
        <div class="kqb-media-list kqb-media-list2">
          <div class="kqb-media-item" v-for="(item,index) in knowledgeFreeList" :key="index" @click="pageJump('/mediaRecommendationDetail',item)">
            <!-- fileType=mp3&goodsId={{item.goodsId}}&goodsLecturerName={{item.goodsLecturerName}}&goodsBriefDesc={{item.goodsBriefDesc}}&goodsLecturerDesc={{item.goodsLecturerDesc}}&goodsQuantity={{item.goodsQuantity}}&countStudy={{item.countStudy}}&goodsNo={{item.goodsNo}}&goodsDetailImgs={{item.goodsNativeDetailDesc}}" -->
            <img v-lazy="item.goodsImgs" class="kqb-media-object" />
            <div class="kqb-media-inner">
              <div class="kqb-media-title ellipsis">{{item.goodsLongName}}</div>
              <div class="kqb-media-desc ellipsis tl"></div>
              <div class="kqb-media-label">{{'主讲人：'+item.goodsLecturerName}}</div>
              <div class="kqb-media-footer">
                <div class="fc-F82E3D">{{item.goodsQuantity}}课<label v-if="item.goodsIsVip == 1">/VIP</label></div>
                <div class="fc-aaa">{{(item.countStudy?item.countStudy:0) +'人学习'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'curriculumSchedule',
  data () {
    return {
      current: 0,
      category: '已学课程',
      goodsCategoryId: '',
      knowledgeFreeList: []
    }
  },
  created () {
    let params = this.$route.query
    var url = window.location.href
    if (url.indexOf('mianfei') > -1) {
      this.category = '免费课程'
      this.getKnowledgeFreeSubjec(0)
    } else if (url.indexOf('vip') > -1) {
      this.category = 'VIP课程'
      this.getKnowledgeFreeSubjec(1)
    } else if (url.indexOf('yixue') > -1) {
      this.getKnowledgeYixue()
    }else if(url.indexOf("mixun") > -1){ //来源密训课堂
      console.log("密训课堂")
      this.category = '密训课堂'
      this.goodsCategoryId = params.goodsCategoryId
      console.log(this.goodsCategoryId)
      this.selectByGoodsCategoryId();
    } else {
      this.category = params.goodsCategoryName
      this.goodsCategoryId = params.goodsCategoryId
      this.getKnowledgeClassification()
    }
    // if ('freeSubject' == category) {
    //   this.getKnowledgeFreeSubjec()
    // } else if ('finishLearned' == category) {
    //   this.getKnowledgeFinishedSubjec()
    // } else if ('classification' == category) {
    //   var goodsCategoryId = options.goodsCategoryId
    //   that.setData({
    //     goodsCategoryId: goodsCategoryId
    //   })
    //   this.getKnowledgeClassification()
    // }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    switchTab (index) {
      const thisObj = this
      this.current = index
      thisObj.getKnowledgeFreeSubjec()
    },
    // 获取结束数据
    getFinishedSubjects: function () {
      const thisObj = this
      thisObj.$api.get('/knowledge/goods/info/getFinishedSubjects', {}).then(res => {
        if (res.data.resultCode === 200 && res.data.success) {
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 从免费入口进入
    getKnowledgeFreeSubjec: function (isVip) {
      const thisObj = this
      var storeId = this.$root.userInfo.storeId
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/info/getFreeSubjects?fromDevice=h5&goodsIsVip=' + isVip + '&storeId=' + storeId, {}).then(res => {
        if (res.resultCode === 200 && res.success) {
          this.knowledgeFreeList = res.resultData
        } else {
          thisObj.$util.requetServerError(res.data.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 获取结束科目数据
    getKnowledgeFinishedSubjec: function () {
      const thisObj = this
      thisObj.$api.get('/knowledge/goods/info/getKnowledgeFinishedSubjec', {}).then(res => {
        if (res.data.resultCode === 200 && res.data.success) {
          // if (res.data.resultData.length <= 5) {
          //   thisObj.guessFavoriteList = res.data.resultData
          // } else {
          //   let guessFavoriteList = []
          //   for (let i = 0; i <= 4; i++) {
          //     guessFavoriteList.push(res.data.resultData[i])
          //   }
          //   thisObj.guessFavoriteList = guessFavoriteList
          // }
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 获取分类课程数据
    getKnowledgeClassification: function () {
      const thisObj = this
      var storeId = this.$root.userInfo.storeId
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/category/getKnowledgeGoodsCategoryId?fromDevice=h5&goodsCategoryId=' + this.goodsCategoryId + '&storeId=' + storeId, {}).then(res => {
        if (res.success) {
          this.knowledgeFreeList = res.resultData
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 获取分类课程数据
    getKnowledgeYixue: function () {
      var thisObj = this
      var person = this.$root.userInfo
      var uri = thisObj.requestUrl + '/knowledge/goods/info/getFinishedSubjects?fromDevice=h5&personId=' + person.personAccountInfoId + '&personToken=' + person.personAccountToken + '&loginTimestamp=' + person.personLoginTimeStamp + '&personOpenId=' + person.personAccountInfoDsfOpenId
      thisObj.$api.get(uri, {}).then(res => {
        if (res.success) {
          this.knowledgeFreeList = res.resultData
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 获取密训课堂
    selectByGoodsCategoryId(){
      const that = this;
      var goodsCategoryId = that.goodsCategoryId;

      that.$api
      .get(
        that.requestUrl+
        "/knowledge/goods/selectByGoodsCategoryId/"+goodsCategoryId+"?fromDevice=h5",
        {}
      )
      .then((res) => {
        if(res.success){
          console.log(res)
          that.knowledgeFreeList = res.resultData
        }else{
          that.$util.requetServerError("查询失败")
        }
      })
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      var person = this.$root.userInfo
      let queryData = {
        fileType: item.goodsType,
        goodsId: item.goodsId,
        goodsName: item.goodsLongName,
        goodsLecturerName: item.goodsLecturerName,
        goodsBriefDesc: item.goodsBriefDesc,
        goodsLecturerDesc: item.goodsLecturerDesc,
        goodsQuantity: item.goodsQuantity,
        countStudy: item.countStudy,
        goodsNo: item.goodsNo,
        goodsDetailImgs: item.goodsNativeDetailDesc,
        goodsFirstImg: item.goodsFirstImg,
        goodsIsVip: item.goodsIsVip,
        isUser: '0',
        storeId: person.storeId,
        userId: person.personAccountInfoId
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    }
  }
}
</script>
<style scoped>
/* .page {
  background: #fff;
} */
 html,body,#app{
    background-color: #eae8e8;
  }
.kqb-tab {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 95px;
  padding: 0 20%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 18px 0px rgba(216, 232, 253, 0.45);
}

.kqb-tab-item {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(143, 143, 143, 1);
}

.kqb-tab-item.active {
  color: rgba(51, 51, 51, 1);
}

.kqb-tab-item text {
  display: inline-block;
  margin: -12px 0 0 0;
}

.kqb-tab-item .tab-line {
  display: none;
  position: absolute;
  bottom: 8px;
  left: 50%;
  width: 58px;
  height: 18px;
  transform: translate(-50%, 0);
  z-index: 111;
}

.kqb-tab-item.active .tab-line {
  display: block;
}
.kqb-media-list2 .kqb-media-item {
  max-width: 4.3205rem;
  width: 45%;
}
.kqb-media-list2 .kqb-media-item .kqb-media-label {
  width: 300px;
}

.kqb-media-inner .kqb-media-footer div.fc-F82E3D {
  color: #f82e3d;
}

.kqb-media-inner .kqb-media-footer div.fc-aaa {
  color: #aaa;
}
</style>
